import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer-container'>
        <div class='footer-logo'>
          <small class='website-rights'>Quantiq Financial © 2024</small>
        </div>
    </div>
  );
}

export default Footer;
